function BlanksIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          d='M12.5 28H10.2639L9.5 25.8814H5.48611L4.73611 28H2.5L6.47222 18H8.56944L12.5 28ZM6.875 21.9831L6.04167 24.3418H8.94444L8.09722 21.9831C7.875 21.3616 7.66667 20.6836 7.51389 19.9774H7.45833C7.30556 20.6836 7.09722 21.3616 6.875 21.9831Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.5 4H4.5V11H11.5V4ZM4.5 2C3.39543 2 2.5 2.89543 2.5 4V11C2.5 12.1046 3.39543 13 4.5 13H11.5C12.6046 13 13.5 12.1046 13.5 11V4C13.5 2.89543 12.6046 2 11.5 2H4.5Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M28.5 19H21.5V26H28.5V19ZM21.5 17C20.3954 17 19.5 17.8954 19.5 19V26C19.5 27.1046 20.3954 28 21.5 28H28.5C29.6046 28 30.5 27.1046 30.5 26V19C30.5 17.8954 29.6046 17 28.5 17H21.5Z'
          fill='currentColor'
        />
        <path
          d='M21.4826 11.8745H19.5V2H21.3257L24.8344 6.1841C25.3764 6.85356 25.9184 7.50907 26.5745 8.38773H26.6173C26.5174 7.50907 26.5032 6.83961 26.5032 5.90516V2H28.5V12H27.088L23.1941 7.43933C22.6379 6.78382 22.0816 6.10042 21.4113 5.2357H21.3827C21.4683 6.10042 21.4826 6.78382 21.4826 7.71827V11.8745Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default BlanksIcon;
